// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1dDlL","inputWrap":"styles_inputWrap__3kv8Z","input":"styles_input__1obMl"};